export const SET_CAMERA_STATUS = 'SET_CAMERA_STATUS';
export const SET_CAMERA_QUEUE = 'SET_CAMERA_QUEUE';
export const SET_FIRST_SRS = 'SET_FIRST_SRS';
export const SET_PAN_ZOOM = 'SET_PAN_ZOOM';
